import Plyr from 'plyr/dist/plyr.polyfilled.js';

import '../../sass/blocks/video.scss';

(() => {
    const $videos = document.querySelectorAll('.video');

    if (!$videos) return;

    $videos.forEach($video => {
        const $videoPlayer = $video.querySelector('.video__video-player');
        const $videoPlayBtn = $video.querySelector('.video__video-play-btn');
        
        const { poster } = $videoPlayer.dataset;

        const initVideo = () => {
            const player = new Plyr($videoPlayer, {
                controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
            });

            $videoPlayBtn.addEventListener('click', () => {
                player.play();
            }, { passive: true });

            if (poster) {
                player.on('ready', () => {
                    player.poster = poster;
                });
            }
        };

        initVideo();
    });
})();
